import axios from 'axios';
import { req ,getByobj} from './axiosFun';

/**
 * 首页统计模块
 **/
// get 实时支付金额
export const realTimePaymentAmount = (params) => { return getByobj("get", "/statistics/realTimePaymentAmount", params) };
// get 支付概况
export const paymentSituation = (params) => { return getByobj("get", "/statistics/paymentSituation", params) };
// get 流量概况
export const trafficOverview = (params) => { return getByobj("get", "/statistics/trafficOverview", params) };
// get 交易转化
export const transactionConversion = (params) => { return getByobj("get", "/statistics/transactionConversion", params) };
// get 新老客户成交
export const newAndOldCustomerTransactions = (params) => { return getByobj("get", "/statistics/newAndOldCustomerTransactions", params) };
// get TOP5商品支付金额
export const productTransactionRanking = (params) => { return getByobj("get", "/statistics/productTransactionRanking", params) };
// get 退款概况
export const returnOverview = (params) => { return getByobj("get", "/statistics/returnOverview", params) };
// get 访问-支付转化率
export const paymentConversionRate = (params) => { return getByobj("get", "/statistics/paymentConversionRate", params) };
// get 访客人数
export const numberVisitors = (params) => { return getByobj("get", "/statistics/numberVisitors", params) };
// get 累积会员数（人）
// export const numberVisitors = (params) => { return getByobj("get", "/statistics/numberVisitors", params) };
// get 成交会员数（人）
// export const numberVisitors = (params) => { return getByobj("get", "/statistics/numberVisitors", params) };
// get 会员活跃
// export const numberVisitors = (params) => { return getByobj("get", "/statistics/numberVisitors", params) };
// get 会员概况
// export const numberVisitors = (params) => { return getByobj("get", "/statistics/numberVisitors", params) };
// get 加购概况
// export const numberVisitors = (params) => { return getByobj("get", "/statistics/numberVisitors", params) };
// get 退款原因排行
export const reasonRefundTOP = (params) => { return getByobj("get", "/statistics/reasonRefundTOP", params) };
// get 支付人数（人）
export const numberPayers = (params) => { return getByobj("get", "/statistics/numberPayers", params) };
// get 下单概况
export const placeOrder = (params) => { return getByobj("get", "/statistics/placeOrder", params) };



// WEBPACK FOOTER //
// ./src/api/statistics.js